import styles from './download.module.scss';
import Image from 'next/image';

const FooterDownloadButtons = () => {
  return (
    <div className={styles.appPlatformLogos}>
      <a
        href="https://apps.apple.com/us/app/hera-flight/id6749022937"
        target="_blank"
        rel="noopener noreferrer"
        className={styles.storeLink}
      >
        <Image
          className={styles.groupIcon}
          width={133}
          height={40}
          style={{ width: '133px', height: '40px' }}
          alt="Download on the App Store"
          src="/img/footer/appStore.svg"
        />
      </a>
      <a
        href="https://play.google.com/store/apps/details?id=com.heraflight.app"
        target="_blank"
        rel="noopener noreferrer"
        className={styles.storeLink}
      >
        <Image
          className={styles.groupIcon1}
          width={133}
          height={40}
          style={{ width: '133px', height: '40px' }}
          alt="Get it on Google Play"
          src="/img/footer/googlePlay.svg"
        />
      </a>
    </div>
  );
};

export default FooterDownloadButtons;
